// EVA-6019 — holds the snapshot the XDA toolbar's "filter to wells" button
// restores on toggle-off (the prior filter state + map camera).
//
// Intentional exception to the per-widget scoped-store pattern: this mirrors the
// single global Redux `filter.wellListFilter` it reverts — there is one active
// filter for the app, not one per widget — so a single global create() store is
// correct here (same documented exception as `visDimensionsStore.ts`). The
// snapshot is tagged with the applied filter entry's id (forFilterId) and only
// consumed when it still matches the active XDA filter, so it can never be
// applied to an xda-tagged filter introduced by another path.
import { create } from "zustand";

import { IFilterState } from "models/filter";

export interface XdaFilterRevertSnapshot {
  filterState: IFilterState;
  mapState: { lat: number; lng: number; zoom: number };
  forFilterId: string;
}

interface XdaFilterRevertStore {
  snapshot: Maybe<XdaFilterRevertSnapshot>;
  setSnapshot: (snapshot: XdaFilterRevertSnapshot) => void;
  clearSnapshot: () => void;
  reset: () => void;
}

const initialState: Pick<XdaFilterRevertStore, "snapshot"> = { snapshot: null };

export const useXdaFilterRevertStore = create<XdaFilterRevertStore>()((set) => ({
  ...initialState,
  setSnapshot: (snapshot) => set({ snapshot }),
  clearSnapshot: () => set({ snapshot: null }),
  reset: () => set(initialState)
}));
